import { withStyles, WithStyles } from '@material-ui/core/styles';
import { debounce } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Dispatch } from 'src/config/Store';

import SearchInput from '../SearchInput';

type Props = WithStyles & {};

const styles = (theme) => ({
  inputWrapper: {
    padding: 16,
    borderBottom: `solid ${theme.mhBorderWidth} ${theme.mhBorderColor}`,
  },
});

export enum ChatSearchPanelTestID {
  SearchInput = 'ChatSearchPanelTestID.SearchInput',
}

const ChatSearchPanel: React.FC<Props> = () => {
  const { replace } = useHistory();
  const dispatch = useDispatch<Dispatch>();

  const [searchFilter, setSearchFilter] = useState('');

  useEffect(() => {
    return () => setSearchFilter('');
  }, []);

  const searchConversationsByName = useCallback(
    (name: string) => {
      replace('/chat');
      dispatch.chat.searchConversations(name);
    },
    [dispatch],
  );

  const search = useCallback(debounce(searchConversationsByName, 500), [searchConversationsByName]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.persist();
    setSearchFilter(event.target.value);
    search(event.target.value);
  };

  return (
    <div className="flex p-4 border-b border-gray-200">
      <SearchInput
        value={searchFilter}
        onChange={handleInputChange}
        inputClassName="bg-gray-200 text-gray-600 font-semibold placeholder-gray-600"
        dataTestID={ChatSearchPanelTestID.SearchInput}
      />
    </div>
  );
};

export default withStyles(styles)(ChatSearchPanel);
